import { WebUrl } from "shared-web/lib/webUrl"

export function adminManualJournalEntries(): WebUrl {
  return {
    pathname: `/admin/manual-journal-entries`,
  }
}

export function adminManualJournalEntry(id: string): WebUrl {
  return {
    pathname: `/admin/manual-journal-entries/${id}`,
  }
}

export function adminNewManualJournalEntry(duplicateFromId?: string): WebUrl {
  return {
    pathname: `/admin/manual-journal-entries/new`,
    query: duplicateFromId ? { duplicateFrom: duplicateFromId } : undefined,
  }
}

export function adminEditManualJournalEntry(id: string): WebUrl {
  return {
    pathname: `/admin/manual-journal-entries/${id}/edit`,
  }
}
